<template>
  <div class="index">
    <div class="index-header">
      <el-form :model="form" :inline="true" label-width="100px">
        <div class="input-box">
          <div>
            <el-form-item label="姓名：" prop="name">
              <el-input v-model="form.name" placeholder="请输入姓名"></el-input>
            </el-form-item>
            <el-form-item label="联系电话：" prop="phone">
              <el-input v-model="form.phone" placeholder="请输入电话"></el-input>
            </el-form-item>
            <el-form-item   label="身份证号：">
              <el-input   v-model="form.idCard" 
                    placeholder="请输入身份证号"></el-input>
            </el-form-item>
          </div>
          <div>
            <label style="margin:5px 10px 0 50px;">地区：</label>
          </div>
          <div style="margin-right:10px">
            <Area :value="area_data" :diss="dis" :arr="arrPlace1" @getPlace="getPlace1"/>
          </div>
          <div style="margin-right:10px">
            <el-form-item label="开始时间：" prop="startCreateTime">
              <el-date-picker type="date" v-model="form.startCreateTime" value-format="timestamp" placeholder="选择日期" />
            </el-form-item>
            <el-form-item label="结束时间：" prop="endCreateTime">
              <el-date-picker type="date" v-model="form.endCreateTime" value-format="timestamp" placeholder="选择日期" />
            </el-form-item>
          </div>
          <div>
            <el-form-item>
              <el-button
                type="primary" icon="el-icon-search"
                @click=" $data.paging_data.pageSize = $data.paging_data.total = 1 ,
                Filter_file({api:api,data:form,callback:_d => tableData = _d })">查询</el-button>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </div>
    <div class="edit">
      <el-button :disabled="selectRow.length==1?false:true" v-if="showBtn[1].isShow" icon="el-icon-edit" @click="openBox('edit')">编辑</el-button>
      <el-button icon="el-icon-edit" v-if="showBtn[3].isShow" @click="openBox('create')">创建</el-button>
      <el-button icon="el-icon-delete" v-if="showBtn[2].isShow" type="danger" @click="deleteDate('jycyfwbt_nclwjjr')">删除</el-button>
      <el-button style="padding: 0" v-if="showBtn[4].isShow"><file_Upload :_url="$public.upload_url._q"></file_Upload></el-button>
      <el-button type="primary" @click="downShow = true" icon="el-icon-document-remove">
        <!-- <a style="color:#fff" href="../model/农村劳务经纪人--导入.xls" download="农村劳务经纪人.xls">下载模板</a> -->
        下载模板
      </el-button>
      <el-button v-if="showBtn[5].isShow" type="primary" v-loading.fullscreen.lock="lodaingTime" @click="Filter_export(`${api}/export`,form)" icon="el-icon-document-remove">导出数据</el-button>
    </div>
    <div class="table">
      <el-table
        :data="tableData"
        max-height="550"
        border
        @selection-change="handleSelectionChange"
        style="width: 99.9%">
        <el-table-column
          type="selection"
          width="40">
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          v-for="(item,index) in baseInfo"
          :key="index"
          :prop="item.key"
          width="100"
          :fixed="index>7?false:true"
          :label="item.value"
          align="center">
        </el-table-column>
      </el-table>
      <paging
          :pagesData="$data.paging_data"
          @set_page_number = 'get_page_number'
      ></paging>
    </div>
    <!-- 模态框 -->
    <el-dialog
      title="农村劳务经纪人统计表"
      :visible.sync="centerDialogVisible"
      :modal="false"
      @close="close"
      width="1400px"
      :close-on-click-modal="false"
      center>
      <div>
        <div class="edit-box">
          <div class="edit-item">
            <div class="edit-left">基本信息</div>
            <div class="edit-right">
              <div class="info-box">
                <div class="info-input">
                  <el-form label-width="210px" :rules="rules" ref="editForm" size="mini" :model="editForm">
                    <el-row>
                      <el-col :span="12">
                        <el-form-item label="地区：">
                          <Area   :value="area_data"
                              :diss="dis"
                              :name="arrPlace"
                              @getPlace="getPlace"/>
                        </el-form-item>
                        <el-form-item prop="name" label="姓名：">
                          <el-input style="width:193px;" v-model="editForm.name"></el-input>
                        </el-form-item>
                        <el-form-item prop="idCard" label="身份证号：">
                          <el-input style="width:193px;" v-model="editForm.idCard"></el-input>
                        </el-form-item>
                        <el-form-item label="申报状态：">
                          <el-select size="mini" filterable v-model="editForm.status" placeholder="请选择">
                            <el-option
                              v-for="item in $public.shengbaozhuangtai"
                              :key="item.label"
                              :label="item.label"
                              :value="item.label">
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="人员状态：">
                          <el-select size="mini" filterable v-model="editForm.personStatus" placeholder="请选择">
                            <el-option
                              v-for="item in $public.zaigangzhuangtai"
                              :key="item.label"
                              :label="item.label"
                              :value="item.label">
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="性别：">
                          <el-select size="mini" v-model="editForm.sex" placeholder="请选择">
                            <el-option
                              v-for="item in $public.sex"
                              :key="item.label"
                              :label="item.label"
                              :value="item.label">
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="经办时间：">
                          <el-date-picker
                            style="width:193px;"
                            v-model="editForm.dealTime"
                            value-format="yyyy-MM-dd"
                            type="date"
                            placeholder="选择日期">
                          </el-date-picker>
                        </el-form-item>
                        <el-form-item label="政治面貌：">
                          <el-select size="mini" filterable v-model="editForm.politics" placeholder="请选择">
                            <el-option
                              v-for="item in $public.zhengzhimianmao"
                              :key="item.label"
                              :label="item.label"
                              :value="item.label">
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="学历水平：">
                          <el-select size="mini" filterable v-model="editForm.education" placeholder="请选择">
                            <el-option
                              v-for="item in $public.wenHuaCD"
                              :key="item.label"
                              :label="item.label"
                              :value="item.label">
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="参加工作时间：">
                          <el-date-picker
                            style="width:193px;"
                            value-format="yyyy-MM-dd"
                            v-model="editForm.startWorkTime"
                            type="date"
                            placeholder="选择日期">
                          </el-date-picker>
                        </el-form-item>
                        <el-form-item prop="phone" label="联系电话：">
                          <el-input style="width:193px;" v-model="editForm.phone"></el-input>
                        </el-form-item>
                        <el-form-item label="个人银行账号：">
                          <el-input style="width:193px;" v-model="editForm.bankNo"></el-input>
                        </el-form-item>
                        <el-form-item label="开户银行：">
                          <el-input style="width:193px;" v-model="editForm.bankName"></el-input>
                        </el-form-item>
                        <el-form-item label="户籍地：">
                          <el-input style="width:193px;" v-model="editForm.domicile"></el-input>
                        </el-form-item>
                        <el-form-item label="申请工作地域：">
                          <el-input style="width:193px;" v-model="editForm.applyArea"></el-input>
                        </el-form-item>
                        <el-form-item label="退出原因：">
                          <el-input style="width:193px;" v-model="editForm.exitReason"></el-input>
                        </el-form-item>
                        <el-form-item label="退出时间：">
                          <el-date-picker
                            style="width:193px;"
                            value-format="yyyy-MM-dd"
                            v-model="editForm.exitTime"
                            type="date"
                            placeholder="选择日期">
                          </el-date-picker>
                        </el-form-item>
                        <el-form-item label="经办地区：">
                          <el-input style="width:193px;" v-model="editForm.dealArea"></el-input>
                        </el-form-item>
                        <el-form-item label="录入人：">
                          <el-input style="width:193px;" v-model="editForm.dealPerson"></el-input>
                        </el-form-item>
                        <el-form-item label="录入时间：">
                          <el-date-picker
                            style="width:193px;"
                            value-format="yyyy-MM-dd"
                            v-model="editForm.dealTime"
                            type="date"
                            placeholder="选择日期">
                          </el-date-picker>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit()">确 定</el-button>
      </span>
    </el-dialog>
    <dowmloadplace :value="type" :downShow="downShow" @cutOff="cutOff"/>
  </div>
</template>
<script>
import mixins from '@/Mixins'
export default {
  mixins:[mixins],
  data() {
    return{
      api:'/user/villageAgent',
      form:{},
      type:'9',
      centerDialogVisible:false,
      tableData:[],
      selectRow:[],
      baseInfo:[
        {key: 'province', value: '省'},
        {key: 'city', value: '市'},
        {key: 'county', value: '县'},
        {key: 'town', value: '镇'},
        {key: 'village', value: '村'},
        {key: 'name', value: '姓名'},
        {key: 'idCard', value: '身份证号码'},
        {key: 'status', value: '申报状态'},
        {key: 'personStatus', value: '人员状态'},
        {key: 'sex', value: '性别'},
        {key: 'politics', value: '政治面貌'},
        {key: 'education', value: '学历水平'},
        {key: 'startWorkTime', value: '参加工作时间'},
        {key: 'phone', value: '联系电话'},
        {key: 'bankNo', value: '个人银行账号'},
        {key: 'bankName', value: '开户银行'},
        {key: 'domicile', value: '户籍地'},
        {key: 'applyArea', value: '申请工作地域'},
        {key: 'exitReason', value: '退出原因'},
        {key: 'exitTime', value: '退出时间'},
        {key: 'dealArea', value: '经办地区'},
        {key: 'dealPerson', value: '录入人'},
        {key: 'dealTime', value: '录入时间'},
      ],
      rules:{
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入电话', trigger: 'blur' }
        ],
        idCard: [
          { required: true, message: '请输入身份证号', trigger: 'blur' },
          { min: 18, max: 18, message: '长度为18个字符', trigger: 'blur' }
        ],
      },
      isCreate:false,
    }
  },
  created() {
    this.isShowBtn("VillageAgent")//控制操作按钮的显示与隐藏
    this.getArea({value:{areaId:0},key:0})
  },
  methods:{
    handleSelectionChange(val) {
      this.selectRow = val
    },
    //分页
    get_page_number(pageNumer) {
      let [vm] = [this]
      vm.form.pageNumber = pageNumer;
      vm.Filter_file({api:vm.api,data:vm.form,callback:_d => vm.tableData = _d})
    },
    //提交请求
    submit() {
      let newForm = {}
      newForm = JSON.parse(JSON.stringify(this.editForm))
      delete newForm.areaId
      
      newForm.startWorkTime = new Date(newForm.startWorkTime).getTime()
      newForm.dealTime = new Date(newForm.dealTime).getTime()
      newForm.exitTime = new Date(newForm.exitTime).getTime()
      newForm.province = this.province
      newForm.city = this.city
      newForm.county = this.county
      newForm.town = this.town
      newForm.village = this.village
      this.$refs['editForm'].validate((valid)=>{
        if (valid && this.isCreate === true) {
          this.$api.create(this.api,newForm)
          .then(res =>{
            if (res.data.status === 0) {
              this.$message.success('创建成功!')
              this.Filter_file({ api: this.api, data: this.form, callback: _d => this.tableData = _d })
            } else {
							this._status(res.data)
						}
          })
        } else if (valid && this.isCreate === false) {
          delete newForm.createTime
          this.$api.change(`${this.api}/modify`,newForm)
          .then(res =>{
            if (res.data.status === 0) {
              this.$message.success('修改成功!')
              this.Filter_file({ api: this.api, data: this.form, callback: _d => this.tableData = _d })
            } else {
							this._status(res.data)
						}
          })
        } else {
          return false
        }
      })
    },
  }
}
</script>
<style>
/* .index .index-header .el-form-item__content{width: 200px;} */
.input-box>div{display: flex;flex-direction: column;flex-shrink: 0;}
</style>